import React from 'react';
import HeaderSSR from '../../components/HeaderSSR';
import FooterSSR from '../../components/FooterSSR';
import DeleteAccountContent from '../../components/DeleteAccountContent';

export default function DeleteAccountPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <HeaderSSR />

      <main className="max-w-3xl mx-auto px-4 py-12 pt-24">
        <DeleteAccountContent />
      </main>

      <FooterSSR />
    </div>
  );
}
